// Корневой layout дерева роутов.
//
// Сейчас — только Outlet. Сюда встанут AppShell из @restomarker/ui-kit, баннер
// «нет сети» (offline-first.md §9) и Error Boundary уровня роута (code-quality.md §6).

import { Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';

export function RootLayout(): ReactElement {
  return <Outlet />;
}
